import { render, staticRenderFns } from "./AttrEditTable.vue?vue&type=template&id=44bced55&"
import script from "./AttrEditTable.vue?vue&type=script&lang=ts&"
export * from "./AttrEditTable.vue?vue&type=script&lang=ts&"
import style0 from "./AttrEditTable.vue?vue&type=style&index=0&id=44bced55&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports